
import { makeStyles } from '@material-ui/core/styles'
import SplashPage from '@scoir/splash-page'

import ScoirApplyIcon from './AwSlogo.svg'
import artwork from './Splash-My-Colleges.png'

const useStyle = makeStyles({
  icon: {
    boxShadow: 'inset 0 0 0px 1px #c3e36a',
    backgroundColor: '#ffffff',
    borderRadius: '100%',
  },
})

const DashboardSplashPage = () => {
  const classes = useStyle()
  return (
    <SplashPage
      title={
        <span>
          Build Your
          <br />
          List and Apply
          <br />
          to 140+ Colleges
        </span>
      }
      body="With Scoir, you can discover best-fit colleges, build your list, and when it's time, apply with confidence to over 140 Coalition colleges."
      artwork={artwork}
      artworkProps={{ alt: 'Sign in to Discover Eligible Colleges' }}
      buttonText="Discover Eligible Colleges"
      buttonHref="/student/discover/search?page=1&predefinedFilters=APPLY_WITH_SCOIR"
      buttonStartIcon={
        <img
          className={classes.icon}
          alt="Apply with Scoir"
          src={ScoirApplyIcon}
        />
      }
    />
  )
}

export default DashboardSplashPage
